export default "__VITE_ASSET__C50wqJWL__"